export const adminNavBarRoutes = {
  role: "ADMIN",
  routes: [
    {
      label: "Training",
      name: "/training",
    },
    {
      label: "Training Center",
      name: "/training-center",
    },
    {
      label: "Employee",
      name: "/employee",
    },
    {
      label: "Module Center",
      name: "/module-center",
    },
    {
      label: "Evaluation",
      name: "/evaluation"
    }
  ],
};

export const assigneeNavBarRoutes = {
  role: "USER",
  routes: [
    {
      label: "Training",
      name: "/training",
    },
  ],
};
